export default __webpack_public_path__ + "static/media/img7.947e2ce5.jpg";